import React, { useLocation } from "wouter";
import { months, years } from "../config";
import { uploadBustePagaMassive } from "../services/api";
import UploadForm from "./upload_form";
import { useState } from "react";
import { LocalCafe } from "@mui/icons-material";
// import { useNavigate } from 'wouter';


export default function CardCaricaBp(props) {
  // const navigate = useNavigate()

  const [location, setLocation] = useLocation();
  
  return (
    <div className = "overflow-hidden rounded-lg bg-white mb-10" >
      <div className="p-2">
        <h2 className="text-base font-medium text-gray-900" id="recent-hires-title">
          Carica Buste Paga Massive
        </h2>
        <div className="mt-6 flow-root">
          <UploadForm
            enableUpload={true}
            message={{
              success: ({ anno, mese, year, month }) => {
                const y = year ?? anno;
                const m = month ?? mese;

                return (
                  <button
                    type="button"
                    className="text-amber-700 underline font-semibold"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      const base = (location || "").split("?")[0];
                      const qs = new URLSearchParams();
                      if (y) qs.set("year", String(y));
                      if (m) qs.set("month", String(m));
                      qs.set("focus", "1");

                      setLocation(`${base}?${qs.toString()}`);

                      Promise.resolve().then(() => props.setClose(false));
                    }}
                  >
                    Per confermare i documenti clicca qui
                  </button>
                );
              },
            }}
            fields={
              [
                { name: 'year', label: 'Anno', type: 'select', options: years },
                { name: 'month', label: 'Mese', type: 'select', options: months },
                {
                  name: 'notify_employee', label: 'Notifica i dipendenti via email', defaultChecked: true, type: 'checkbox', options: [
                    { label: 'Si', value: true }
                  ]
                },
                { type: 'hidden', name: 'anagrafica_create_missing', value: 'true' },
                { type: 'hidden', name: 'typology', value: 'bp' }
              ]
            }
            formType="BustePagaMassive"
            submitLabel="Carica"
            submitAction={uploadBustePagaMassive}
          />
        </div>
      </div>
    </div>
  )

}